<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div
        class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        "
      >
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >หน้าแรก</router-link
              >
            </li>
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/RequestCert"
                >ขอหนังสือรับรองการทำงาน
              </router-link>
            </li>
            <li class="breadcrumb-item router-link active">
              หนังสือรับรองการทำงานภาษาไทย
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div
        class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        "
        style="background-color: #f2f2f2"
      >
        <div class="icon-back">
          <router-link to="/RequestCert">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div
          class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8"
        >
          หนังสือรับรองการทำงานภาษาไทย
        </div>
      </div>
      <!-- Mobile -->
      <div class="col col-content">
        <div class="d-none d-lg-flex align-items-center border-bottom">
          <div class="icon-back">
            <router-link to="/RequestCert">
              <img src="@/assets/images/arrow-blue.svg" class="w-100" />
            </router-link>
          </div>
          <div
            class="
              title
              blue-1
              fw-normal
              ps-md-3
              pe-lg-3
              font-family
              d-none d-md-block d-lg-block
            "
          >
            หนังสือรับรองการทำงานภาษาไทย
          </div>
        </div>
        <div class="pb-3 pb-lg-3">
          <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
            วัตถุประสงค์การขอหนังสือรับรอง
            <span class="required">*</span>
          </div>
          <div class="fs-4 font-family">
            <input
              v-model="this.REASON_DTL"
              type="text"
              class="field field__input a-field__input"
              style="border-bottom: 1px solid #d0d0d0"
              autocomplete="off"
            />
          </div>
        </div>
        <div class="col mt-2 mb-2 mb-lg-2">
          <button class="btn-CB border border-0 rounded w-100 font-family" @click="EnterNext()">
            <label class="btn-next">ดำเนินการต่อ</label>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";

import Swal from 'sweetalert2/src/sweetalert2.js';

export default {
  name: "FinishCertTH",
  components: {
    Menu,
  },
  data() {
    return {
      REASON_DTL: this.$store.state.REQUEST_CERT.CERT_THI.REASON_DTL
    };
  },
  mounted() {
    if(this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }
  },
  methods: {
    EnterNext() {
      if(this.REASON_DTL.trim()  === '' || this.REASON_DTL.trim()  == null) {
        Swal.fire({
          icon: 'error',
          html: '<lable class="fs-4 fw-normal font-family">กรุณาระบุวัตถุประสงค์การขอหนังสือรับรอง</lable>',
        });
      }
      else {
        // SET DATA INSERT
        this.$store.state.REQUEST_CERT.CERT_THI.REASON_DTL = this.REASON_DTL;
        this.$store.state.REQUEST_CERT.CERT_THI.SUCCEED = true;

        this.$router.push('/RequestCert');
      }
    },
  },

};
</script>

<style scoped>
.btn-CB {
  min-height: 50px;
  font-size: 26px;
  font-size: 1.625rem;
  background-color: #0057a8;
}

.href-CB {
  color: #ffffff;
}
</style>